module.exports = __webpack_public_path__ + "static/img/Inspection5.b9e70d1b.png";